// @ts-nocheck
import router from '@/router'

class SessionVariablesHelper {
  create () {
    const { NODE_ENV: environment } = process.env

    window.wecleverDashboardSession = {
      environment,
      userId: 'Not logged',
      userEmail: 'Not logged',
      userRole: 'Not logged',
      platformId: 'Not logged',
      platformSlug: 'Not logged',
      platformName: 'Not logged'
    }
  }

  update () {
    const {
      id_user: userId,
      email: userEmail,
      profile: userRole,
      id_platform: platformId,
      platform_name: platformSlug,
      platform: platformName
    } = router.app.$auth.user()

    if (userId) {
      Object.assign(window.wecleverDashboardSession, {
        userId,
        userEmail,
        userRole,
        platformId,
        platformSlug,
        platformName
      })
    }
  }
}

export default SessionVariablesHelper
